import { connect } from "react-redux";

import VotifySearchComponent from "./VotifySearchComponent";
import { sendVote } from "../VotifyParticipant/participantActionCreators";
import {
  editSearchString,
  dispatchSearchRequest,
  dispatchNextPageRequest,
  sendGetTrackRequest,
} from "./searchActionCreators";

const mapStateToProps = (state) => {
  return {
    searchString: state.search.searchString,
    searchResults: state.search.searchResults,
    isLoading: state.search.isLoading,
    miscSearchResults: state.search.miscSearchResults,
    partyId: state.party.partyId,
    isMore: state.search.isMore,
    participantVotes: state.participant.participantVotes,
    votes: state.participant.votes,
    location: state.router.location,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editSearchString: (string) => dispatch(editSearchString(string)),
    sendVote: (trackUri) => dispatch(sendVote(trackUri)),
    sendSearchRequest: () => dispatch(dispatchSearchRequest()),
    getNextPage: () => dispatch(dispatchNextPageRequest()),
    sendGetTrackRequest: (id) => dispatch(sendGetTrackRequest(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VotifySearchComponent);
